import React, { FC, lazy, Suspense } from 'react'
import { Menu } from '..'
import {
  getBrand,
  getHeaderItemsNew,
  getTranslations,
} from '../../utils/context'

import {
  footerSocials,
  footerColumns,
  footerCopyrights,
  defaultFooterCta,
} from './brandProps'
import { EHeaderCta, EMenuType } from '../Menu/type'

const Footer = lazy(() => import('../Footer'))

export enum EHeaderType {
  BLOG = 'BLOG',
  SERENITY_US = 'SERENITY_US',
  SERENITE = 'SERENITE',
  LIBERTE = 'LIBERTE',
  COMMUNICATION = 'COMMUNICATION',
  COMPTABILITE = 'COMPTABILITE',
  PAIEMENT = 'PAIEMENT',
  PRO = 'PRO',
}

interface ILayoutWithoutHead {
  children: React.ReactNode
  preFooter?: React.ReactNode
  headerBackgroundColor?: string
  isBlog?: boolean
  footerBackground?: string
  partnershipLink?: EHeaderCta
  header?: EHeaderType
  footerColumnsProps?: Array<{ [key: string]: string | boolean }>
}

/**
 * Component
 */
const LayoutWihoutHead: FC<ILayoutWithoutHead> = ({
  children,
  preFooter,
  headerBackgroundColor = 'clearBlue',
  footerBackground = 'clearBlue',
  footerColumnsProps,
  partnershipLink,
}) => {
  const translations = getTranslations()

  const brand = getBrand()

  if (brand === undefined) {
    return <></>
  }

  return (
    <>
      <main>
        <Menu
          headerBackgroundColor={headerBackgroundColor}
          menuItems={getHeaderItemsNew(EMenuType.SHOWCASE)}
          cta={partnershipLink}
        />
        {children}
        <Suspense fallback={<></>}>
          <Footer
            columns={footerColumnsProps ?? footerColumns[brand]}
            copyrights={footerCopyrights[brand]}
            cta={defaultFooterCta[brand]}
            preFooter={preFooter}
            socials={footerSocials[brand]}
            translations={translations}
            path="/"
            platform={getBrand()}
            footerBackground={footerBackground}
          />
        </Suspense>
      </main>
    </>
  )
}

export default LayoutWihoutHead
